import React from 'react'
import { camelCase } from 'lodash'
import cx from 'classnames'
import { Checkbox, Button, Space } from 'antd'
import Icon from 'components/Icon'
import styles from './CheckboxGroup.scss'

const allowedTypes = ['regular', 'circle']
const [TYPE_REGULAR, TYPE_CIRCLE] = allowedTypes

export interface ICheckboxGroup {
  type?: string
  isRow?: boolean
  name: string
  withLabel?: boolean
  withIcons?: boolean
  options: Array<string>
  selections: Array<string>
  customValues?: Array<string>
  onChange: (arg0: string) => void
}

const CheckboxGroup = ({
  type = TYPE_REGULAR,
  isRow = false,
  name,
  withLabel = false,
  withIcons = false,
  options,
  selections,
  onChange,
  customValues,
}: ICheckboxGroup) => (
  <div className={cx(styles.container, styles[type], { [styles.row]: isRow })}>
    <Space direction={isRow ? 'horizontal' : 'vertical'} wrap>
      {options.map((option, index) => {
        const isChecked = selections.includes(option)

        return (
          <div key={index} className={cx(styles.wrapper, styles[type], { [styles.checked]: isChecked })}>
            {type === TYPE_REGULAR ? (
              <Checkbox
                id={`${name}-${index}`}
                name={name}
                checked={isChecked}
                onChange={() => onChange(option)}
                className={cx(styles.checkbox, styles[type])}
              >
                <Space>
                  {withIcons && <Icon size='small' name={camelCase(option)} className={styles.icon} />}
                  <span className={styles.option}>
                    {!!customValues ? customValues[index] : option}
                  </span>
                </Space>
              </Checkbox>
            ) : (
              <Button
                onClick={() => onChange(option)}
                className={cx(styles.button, styles[type], { [styles.checked]: isChecked })}
                type={isChecked ? 'primary' : 'default'}
              >
                <Space>
                  {withIcons && <Icon size='small' name={camelCase(option)} className={styles.icon} />}
                  {type === TYPE_CIRCLE && (
                    <div className={styles.shape}>
                      <div className={styles.inner} />
                    </div>
                  )}
                  <span className={styles.label}>{option}</span>
                </Space>
              </Button>
            )}
            {withLabel && <label htmlFor={`${name}-${index}`}>{option}</label>}
          </div>
        )
      })}
    </Space>
  </div>
)

export default CheckboxGroup
